import { render } from "./LabBook.vue?vue&type=template&id=3404c1e3"
import script from "./LabBook.vue?vue&type=script&lang=js"
export * from "./LabBook.vue?vue&type=script&lang=js"

import "./LabBook.vue?vue&type=style&index=0&id=3404c1e3&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__